import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import shoppingBagFill from '@iconify/icons-eva/shopping-bag-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import lockFill from '@iconify/icons-eva/lock-fill';
import personAddFill from '@iconify/icons-eva/person-add-fill';
import alertTriangleFill from '@iconify/icons-eva/alert-triangle-fill';
import { connect } from 'react-redux';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

export const genSidebarConfig = (currentRole) => {
  const config = [
    {
      title: 'miembros',
      path: '/dashboard/members',
      icon: getIcon(personAddFill)
    },
    {
      title: 'aperturas',
      path: '/dashboard/openings',
      icon: getIcon(fileTextFill)
    }
  ];
  if (currentRole && currentRole === 'admin') {
    config.push({
      title: 'acciones',
      path: '/dashboard/actions',
      icon: getIcon(fileTextFill)
    });
  }
  return config;
};
